import React from 'react';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import useImageDownloadUrl from './useLoadImageDownloadUrl';
import LoadingDisplay from './LoadingDisplay';
import { IconButtonFloat } from '@lifeomic/chroma-react/components/IconButtonFloat';
import { X } from '@lifeomic/chromicons';
import clsx from 'clsx';
import { defineMessages, useIntl } from 'react-intl';

export const useStyles = makeStyles((_theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  imageContainer: {
    position: 'relative',
    display: 'inline-block',
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
  },
  deleteButton: {
    display: 'absolute',
    right: -12,
    top: -12,
    bottom: 'auto',
    padding: 4,
  },
}));

const messages = defineMessages({
  survey: {
    id: 'surveyImage.survey',
    defaultMessage: 'Survey',
  },
  clearImage: {
    id: 'surveyImage.clearImage',
    defaultMessage: 'Clear Image',
  },
});

export type SurveyImageOwnProps = {
  imageId: string;
  surveyId: string;
  onDelete?: () => void;
  className?: string;
};

export type SurveyImageProps = SurveyImageOwnProps;

const SurveyImage: React.FC<SurveyImageProps> = props => {
  const imageDownloadUrl = useImageDownloadUrl(props.imageId, props.surveyId);
  const { formatMessage } = useIntl();
  const classes = useStyles({});

  if (!imageDownloadUrl)
    return (
      <div className={clsx(classes.root, props.className)}>
        <LoadingDisplay />
      </div>
    );

  return (
    <div className={clsx(classes.root, props.className)}>
      <div className={classes.imageContainer}>
        {props.onDelete ? (
          <IconButtonFloat
            icon={X}
            size={0}
            aria-label={formatMessage(messages.clearImage)}
            onClick={props.onDelete}
            className={classes.deleteButton}
          />
        ) : null}
        <img
          alt={formatMessage(messages.survey)}
          className={classes.image}
          src={imageDownloadUrl}
        />
      </div>
    </div>
  );
};

export default React.memo(SurveyImage);
